import { REQUEST_STATUS } from '../constants';
import { REQUEST_STATUS_DATA as BASE_DATA } from '../glossary';

export const REQUEST_STATUS_DATA = {
  [REQUEST_STATUS.new]: {
    ...BASE_DATA[REQUEST_STATUS.new],
    name: 'Ожидает аккредитации',
  },
  [REQUEST_STATUS.accepted]: {
    ...BASE_DATA[REQUEST_STATUS.accepted],
    name: 'Аккредитована',
  },
  [REQUEST_STATUS.rejected]: {
    ...BASE_DATA[REQUEST_STATUS.rejected],
    name: 'Отклонена',
  },
};

export default {
  REQUEST_STATUS_DATA,
};
